import { Routes, Route, Outlet } from 'react-router-dom';
import { BabbelFonts, BabbelThemeProvider } from 'src/viewLayer/components/DesignSystem';
import { withErrorBoundary } from 'src/viewLayer/components/shared/ErrorBoundary';
import { Flow } from 'src/viewLayer/components/Flow';
import Footer from 'src/viewLayer/components/Footer';
import Redirect from 'src/viewLayer/components/Redirect';
import { AppContainer } from './index.styled';
import './index.scss';

const RoutesWrapper = (): JSX.Element => <Outlet />;

export default (): JSX.Element => {
  const getAppComponent = (): JSX.Element => (
    <BabbelThemeProvider defaultMode="light">
      <AppContainer className="AppContainer">
        <BabbelFonts/>
        <Routes>
          <Route path=":locale/:environment" element={ <RoutesWrapper /> }>
            <Route path=":learnLang" element={ <Redirect /> } />
            <Route path=":learnLang/:flowId" element={ <Redirect /> } />
            <Route path=":learnLang/:flowId/node" element={ <Redirect /> } />
            <Route path=":learnLang/:flowId/node/:nodeNumber" element={ <Flow /> } />
            <Route path="" element={ <Redirect /> } />
            {/* Catch all route needed for e.g. path=":flowId/node/:nodeNumber" */}
            <Route path="*" element={ <Redirect /> } />
          </Route>
        </Routes>
        <Footer/>
      </AppContainer>
    </BabbelThemeProvider>
  );

  const WithErrorBoundary = withErrorBoundary({ componentTitle: 'AppComponent' })(getAppComponent);
  return <WithErrorBoundary />;
};
